import {
	Component,
	OnInit,
	OnChanges,
	SimpleChanges,
	OnDestroy,
	Input,
	Output,
	EventEmitter,
	ViewEncapsulation,
	HostListener, HostBinding
} from "@angular/core";
import { IdService } from "../shared/services/id.service";
import { TabTrap } from "../shared/services/tabTrap.service";

@Component({
	selector: "rbc-snackbar",
	templateUrl: "./snackbar.component.html",
	styles: [],
	encapsulation: ViewEncapsulation.None
})
export class SnackbarComponent implements OnInit, OnDestroy, OnChanges {
	@Input() id: string;
	@Input() active;
	@Input() buttonCloseLabel = "Dismiss";
	@Input() text: string;
	@Input() positionX: "left" | "center" | "right" = "center";
	@Input() positionY: "top" | "bottom" = "bottom";
	@Input() timeout: number;
	@Input() timeoutProgress: boolean;
	@Input() title: string;
	@Input() type: "danger" | "success" | "info";
	@Input() headingTag: "h2" | "h3" | "h4" | "h5" | "h6" = "h4";

	@Output() toggle = new EventEmitter();

	@HostBinding("class.rbc-snackbar") snackBar = false;

	get transition() {
		return "opacity-" + this.transitionGen();
	}

	delay = null;
	progressAmount = 0;
	_animation;

	constructor(private idService: IdService, private tabTrap: TabTrap) {
		this.id = this.idService.generate();
		// this.progressAmount = 0;
	}

	@HostListener("document:keydown.escape", ["$event"]) onKeydownHandler(event: KeyboardEvent) {
		if (this.active) {
			this.$_Snackbar_toggle();
		}
	}

	ngOnInit() {
		// this.transition = `opacity-${this.transitionGen()}`;
		this.snackBar = true;
	}

	ngOnDestroy(): void {
		if (this.idService) {
			this.idService.remove(this.id);
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes) {
			if (changes.active) {
				// add toggle timeout if available and active
				if (this.active && this.timeout) {
					this.delay = setTimeout(() => {
						this.$_Snackbar_toggle();
					}, this.timeout);
					// clear timeout if snackbar is not active
				} else if (!this.active) {
					clearTimeout(this.delay);
					this.delay = null;
				}

				// set progress bar
				if (this.active && this.timeoutProgress) {
					// reset animation
					this.progressAmount = 0;
					cancelAnimationFrame(this._animation);

					// grab current time
					const startTime = new Date().getTime();
					// grab end time based on current time and timeout
					const endTime = startTime + this.timeout;
					// start animation
					this.$_Snackbar_progress(endTime);
				}

				if (this.active) {
					setTimeout(() => {
						let mySnackbar = document.getElementById(this.id);
						mySnackbar.focus();
						window.addEventListener("keydown", (e) => this.tabTrap.$_TabTrap_lockFocus(e, mySnackbar));
					}, 50);
				} else {
					window.removeEventListener("keydown", (e) => this.tabTrap.$_TabTrap_lockFocus(e, document.getElementById(this.id)));
				}
			}
		}
	}

	iconGen(): string {
		const icons = {
			danger: "exclamation",
			success: "check",
			warning: "exclamation",
			info: "exclamation"
		};

		return icons[this.type];
	}

	iconBackGen() {
		const icons = {
			danger: "square",
			success: "circle",
			warning: "triangle",
			info: "circle"
		};

		return icons[this.type];
	}

	transitionGen(): string {
		if (this.positionX === "left") {
			return "left";
		} else if (this.positionX === "right") {
			return "right";
		} else if (this.positionY === "top") {
			return "down";
		} else {
			return "up";
		}
	}

	classGen(): string[] {
		return [
			this.positionY
				? `rbc-snackbar-${this.positionY}`
				: "rbc-snackbar-bottom",
			this.positionX
				? `rbc-snackbar-${this.positionX}`
				: "rbc-snackbar-center",
			this.type ? `rbc-snackbar-${this.type}` : ""
		];
	}

	$_Snackbar_toggle(e?: Event) {
		this.toggle.emit();
	}

	$_Snackbar_progress(endTime: number) {
		if (this.progressAmount < 100) {
			let currentTime = new Date().getTime();
			this.progressAmount =
				100 - ((endTime - currentTime) / this.timeout) * 100;
			this._animation = requestAnimationFrame(
				this.$_Snackbar_progress.bind(this, ...arguments)
			);
			// stop animation when step reaches 100%
		} else {
			this.progressAmount = 100;
			cancelAnimationFrame(this._animation);
		}
	}

	$_Snackbar_pause(e?: Event) {
		if (this.timeout) {
			cancelAnimationFrame(this._animation);
			clearTimeout(this.delay);
		}
	}

	$_Snackbar_unpause(e?: Event) {
		if (this.timeout) {
			this.delay = setTimeout(() => {
				this.$_Snackbar_toggle();
			}, this.timeout);
			const startTime = new Date().getTime();
			const endTime = startTime + this.timeout;
			this.$_Snackbar_progress(endTime);
		}
	}
}
